<mat-card
  appearance="outlined"
  class="option-box-container {{ appearance }} {{ direction }}"
  [ngClass]="{
    disabled: disabled,
    selected: isSelected
  }"
  (click)="emitSelection()"
  (keyup.enter)="emitSelection()"
  tabindex="0"
  aria-label="option-box"
  type="radio-button"
  [id]="id"
>
  <div
    [ngClass]="{ selected: isSelected }"
    [id]="id"
    class="checkmark-slot"
    [appDynamicBackgroundImage]="getBackgroundImageSource()"
  ></div>

  <div *ngIf="recommanded" class="recommanded-box">
    <app-green-label [label]="'general.recommande'"></app-green-label>
  </div>

  <mat-card-content class="{{ direction }}">
    <div class="option-box-img" [ngClass]="{ 'hidden-mobile': !imageOnMobile }">
      <ng-content select="img.option-box-img"></ng-content>
    </div>
    <div class="option-box-content">
      <ng-content select="div.option-box-content"></ng-content>
    </div>
  </mat-card-content>
</mat-card>
